<template>
  <div class="j-gis-map-switching">
    <div v-for="(item, index) in switchArray"
         :class="{ 'j-gis-map-switching-card': true, 'active': item.selected }"
         :style="`background-image: url('${item.img}')`"
         :key="index"
         @click="$emit('click', item)"
    >
      <span v-show="item.name">{{item.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "JMapSwitching",
  props: {
    switchArray: {
      type: Array,
      default: () => [
        // { name: '电子地图', img: require('../assets/dzdt-img.png'), selected: false },
        // { name: '影像地图', img: require("../assets/yxdt-img.png"), selected: true },
      ]
    }
  }
}
</script>

<style lang="scss">
.j-gis-map-switching {
  display: flex;
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;

  &:empty {
    background-color: rgba(43,54,77,0.4);
  }

  .j-gis-map-switching-card {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: absolute;
    width: 100%;
    height: 100%;
    transition: all .3s linear;
    background-color: rgba(43,54,77,0.4);
    border: 2px solid rgba(43,54,77,0.1);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 4px;
    overflow: hidden;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 5;

    &.active {
      border-color: rgba(17, 138, 249, 1)!important;
      box-shadow: inset 0 0 8px 0 #118AF9;
    }
    &:hover {
      border-color: rgba(17, 138, 249, 1)!important;
    }

    > span {
      padding: 2px 4px;
      background-color: rgba(15, 19, 30, 0.6);
      line-height: 20px;
      border-radius: 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #FDFDFE;
      font-style: normal;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      display:-webkit-box;         //将对象作为弹性伸缩盒子模型显示。
      -webkit-box-orient:vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
      -webkit-line-clamp: 3;      //几行换行（注意必须设置行高）
      white-space: normal;
      word-break: break-all;
    }

    &:nth-child(2) {
      transform: scale(0.95) translateX(-6px);
      z-index: 4;
    }
    &:nth-child(3) {
      transform: scale(0.9) translateX(-12px);
      z-index: 3;
    }
    &:nth-child(4) {
      transform: scale(0.85) translateX(-18px);
      z-index: 2;
    }
    &:nth-child(5) {
      transform: scale(0.8) translateX(-24px);
      z-index: 1;
    }
  }


  &:hover {
    .j-gis-map-switching-card {
      border-color: #fff;
      &:nth-child(2) {
        transform: scale(1) translateX(-105%);
        transition-delay: 0.01s;
      }
      &:nth-child(3) {
        transform: scale(1) translateX(-205%);
        transition-delay: 0.02s;
      }
      &:nth-child(4) {
        transform: scale(1) translateX(-305%);
        transition-delay: 0.03s;
      }
      &:nth-child(5) {
        transform: scale(1) translateX(-405%);
        transition-delay: 0.03s;
      }
    }
  }
}
</style>
